import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    flex: 1,
    padding: '1rem',
  },
  illustration: {
    width: '7.5rem',
    height: '7.5rem',
    objectFit: 'contain',
  },
  bannerText: {
    margin: 0,
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: neutral[80],
    textAlign: 'center',
    maxWidth: '17.125rem',
  },
});
